import { useRef } from 'react'
import { useRouter } from 'next/navigation'
import { useTheme } from 'next-themes'
import { useDeliveryAppContext } from '@/context/deliveryApp/DeliveryAppContext'
import { useRipple } from '@/hooks/useRipple'

const OrdersListButton = () => {
  const { resolvedTheme } = useTheme()
  const router = useRouter()

  const { currentScreen } = useDeliveryAppContext()
  const ref = useRef(null)
  useRipple(ref, 'rgb(169, 174, 179, 0.3)')

  const handleClick = () => {
    router.push('/orders')
  }
  return (
    <button
      ref={ref}
      className="w-12 h-12 p-[9px] rounded-full relative overflow-hidden"
      onClick={handleClick}
    >
      {currentScreen === 'ordersList' ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 640 512"
          fill={resolvedTheme === 'dark' ? '#e0e0e0' : '#323e48'}
        >
          <path d="M112 0C85.49 0 64 21.49 64 48V96H16C7.163 96 0 103.2 0 112C0 120.8 7.163 128 16 128H272C280.8 128 288 135.2 288 144C288 152.8 280.8 160 272 160H48C39.16 160 32 167.2 32 176C32 184.8 39.16 192 48 192H240C248.8 192 256 199.2 256 208C256 216.8 248.8 224 240 224H16C7.163 224 0 231.2 0 240C0 248.8 7.163 256 16 256H208C216.8 256 224 263.2 224 272C224 280.8 216.8 288 208 288H64V416C64 469 106.1 512 160 512C213 512 256 469 256 416H384C384 469 426.1 512 480 512C533 512 576 469 576 416H608C625.7 416 640 401.7 640 384C640 366.3 625.7 352 608 352V237.3C608 220.3 601.3 204 589.3 192L512 114.7C499.1 102.7 483.7 96 466.7 96H416V48C416 21.49 394.5 0 368 0H112zM544 237.3V256H416V160H466.7L544 237.3zM160 464C133.5 464 112 442.5 112 416C112 389.5 133.5 368 160 368C186.5 368 208 389.5 208 416C208 442.5 186.5 464 160 464zM528 416C528 442.5 506.5 464 480 464C453.5 464 432 442.5 432 416C432 389.5 453.5 368 480 368C506.5 368 528 389.5 528 416z" />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 640 512"
          fill="#6b7280"
        >
          <path d="M352 48H128C119.2 48 112 55.16 112 64V96H240C248.8 96 256 103.2 256 112C256 120.8 248.8 128 240 128H16C7.164 128 0 120.8 0 112C0 103.2 7.164 96 16 96H64V64C64 28.65 92.65 0 128 0H352C387.3 0 416 28.65 416 64V96H458.7C473.6 96 487.8 101.9 498.3 112.4L591.6 205.7C602.1 216.2 608 230.4 608 245.3V368H616C629.3 368 640 378.7 640 392C640 405.3 629.3 416 616 416H576C576 469 533 512 480 512C426.1 512 384 469 384 416H256C256 469 213 512 160 512C106.1 512 64 469 64 416V288H112V332.8C126.1 324.7 142.5 320 160 320C195.5 320 226.6 339.3 243.2 368H352C360.8 368 368 360.8 368 352V64C368 55.16 360.8 48 352 48H352zM464.4 146.3C462.9 144.8 460.9 144 458.7 144H416V240H558L557.8 239.8L557.7 239.6L464.4 146.3zM160 368C133.5 368 112 389.5 112 416C112 442.5 133.5 464 160 464C186.5 464 208 442.5 208 416C208 389.5 186.5 368 160 368zM480 464C506.5 464 528 442.5 528 416C528 389.5 506.5 368 480 368C453.5 368 432 389.5 432 416C432 442.5 453.5 464 480 464zM272 160C280.8 160 288 167.2 288 176C288 184.8 280.8 192 272 192H48C39.16 192 32 184.8 32 176C32 167.2 39.16 160 48 160H272zM240 224C248.8 224 256 231.2 256 240C256 248.8 248.8 256 240 256H16C7.164 256 0 248.8 0 240C0 231.2 7.164 224 16 224H240z" />
        </svg>
      )}
    </button>
  )
}

export default OrdersListButton
